// Mock data for Cloudbase multi-industry platform

export const industries = [
  {
    id: 'coworks',
    name: 'Coworks y Espacios Compartidos',
    description: 'Gestión integral para espacios colaborativos y coworking',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80',
    features: ['Reservas de espacios', 'Control de acceso', 'Facturación automática', 'App móvil personalizada']
  },
  {
    id: 'empresas',
    name: 'Empresas',
    description: 'Soluciones empresariales para gestión de clientes y recursos',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80',
    features: ['CRM avanzado', 'Gestión de proyectos', 'Control de recursos', 'Reportería en tiempo real']
  },
  {
    id: 'inmobiliarias',
    name: 'Inmobiliarias',
    description: 'Plataforma completa para gestión de propiedades y arriendos',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
    features: ['Gestión de propiedades', 'Contratos digitales', 'Pagos automatizados', 'Portal de clientes']
  },
  {
    id: 'multifamilies',
    name: 'Multifamilias',
    description: 'Administración eficiente de edificios residenciales',
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80',
    features: ['Gestión de residentes', 'Control de amenities', 'Gastos comunes', 'Comunicación efectiva']
  },
  {
    id: 'gimnasios',
    name: 'Gimnasios',
    description: 'Automatización completa para centros de entrenamiento',
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80',
    features: ['Gestión de membresías', 'Reserva de clases', 'Control de pagos', 'App para miembros']
  }
];

export const modules = [
  {
    id: 'crm',
    name: 'CRM',
    icon: 'Users',
    description: 'Gestión completa de relaciones con clientes y automatización de procesos',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80'
  },
  {
    id: 'booking',
    name: 'Reservas',
    icon: 'Calendar',
    description: 'Sistema de reservas inteligente para cualquier tipo de espacio o servicio',
    image: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=800&q=80'
  },
  {
    id: 'meetingroom',
    name: 'MeetingRoom',
    icon: 'MonitorPlay',
    description: 'Pantallas inteligentes para salas de reuniones con IA y gestión en tiempo real',
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800&q=80'
  },
  {
    id: 'invoicing',
    name: 'Facturación DTE',
    icon: 'FileText',
    description: 'Facturación electrónica automática integrada con SII Chile y validación en tiempo real',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80'
  },
  {
    id: 'accesscontrol',
    name: 'Control de Acceso',
    icon: 'Zap',
    description: 'Control de acceso integrado con video vigilancia, Azure AD y gestión centralizada',
    image: 'https://erp-back.nyc3.digitaloceanspaces.com/assets_public/Captura-de-pantalla-2025-07-23-a-las-3.45.43-p.-m.png'
  },
  {
    id: 'surveyhub',
    name: 'SurveyHub',
    icon: 'MessageSquare',
    description: 'Mide la satisfacción del cliente con encuestas NPS, CSAT y CES en tiempo real',
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80'
  },
  {
    id: 'app',
    name: 'App Personalizada',
    icon: 'Smartphone',
    description: 'Aplicación móvil con tu marca para una experiencia única',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80'
  },
  {
    id: 'automation',
    name: 'Automatización',
    icon: 'Zap',
    description: 'Flujos de trabajo automatizados para ahorrar tiempo y escalar',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80'
  }
];

export const testimonials = [
  {
    name: 'Camila Aravena',
    role: 'Directora de Operaciones',
    company: 'Launch Cowork',
    text: 'Cloudbase transformó completamente la forma en que gestionamos nuestro cowork. Todo está en un solo lugar.',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80'
  },
  {
    name: 'Rodrigo Alarcón',
    role: 'Gerente General',
    company: 'Everest Gym',
    text: 'La automatización del ciclo de vida de los clientes fue un cambio total para nuestro gimnasio.',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&q=80'
  },
  {
    name: 'Daniela Pizarro',
    role: 'CEO',
    company: 'PropTech Solutions',
    text: 'Nuestra empresa nunca había operado de manera tan eficiente. Es una herramienta imprescindible.',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&q=80'
  },
  {
    name: 'Cristian Muñoz',
    role: 'Director Inmobiliario',
    company: 'Urbana Properties',
    text: 'La plataforma es intuitiva y el soporte técnico es excelente. Muy recomendable.',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&q=80'
  }
];

export const clients = [
  { name: 'Launch Cowork', logo: 'https://via.placeholder.com/120x40/DC2626/FFFFFF?text=Launch' },
  { name: 'Everest', logo: 'https://via.placeholder.com/120x40/DC2626/FFFFFF?text=Everest' },
  { name: 'Makers', logo: 'https://via.placeholder.com/120x40/DC2626/FFFFFF?text=Makers' },
  { name: 'Selva', logo: 'https://via.placeholder.com/120x40/DC2626/FFFFFF?text=Selva' },
  { name: 'M3', logo: 'https://via.placeholder.com/120x40/DC2626/FFFFFF?text=M3' },
  { name: 'IF Cowork', logo: 'https://via.placeholder.com/120x40/DC2626/FFFFFF?text=IF' }
];

export const faqs = [
  {
    question: '¿Cómo se adapta Cloudbase a diferentes industrias?',
    answer: 'Cloudbase es una plataforma modular que se configura según las necesidades específicas de cada industria. Nuestros módulos se adaptan automáticamente a coworks, empresas, inmobiliarias, multifamilias y gimnasios.'
  },
  {
    question: '¿Puedo personalizar la plataforma con mi marca?',
    answer: 'Sí, ofrecemos personalización completa incluyendo logo, colores, dominios personalizados y aplicación móvil con tu marca.'
  },
  {
    question: '¿Qué tipo de automatizaciones ofrece Cloudbase?',
    answer: 'Ofrecemos automatizaciones end-to-end: desde la captación de leads, seguimiento automático, firma de contratos, facturación recurrente hasta programas de fidelización y upselling.'
  },
  {
    question: '¿Cómo funciona la integración con otras herramientas?',
    answer: 'Cloudbase se integra fácilmente con las herramientas más populares del mercado mediante APIs y webhooks. Soportamos integraciones con sistemas de pago, contabilidad, email marketing y más.'
  },
  {
    question: '¿Qué soporte técnico ofrecen?',
    answer: 'Ofrecemos soporte técnico dedicado con tiempos de respuesta rápidos, onboarding personalizado y capacitación continua para tu equipo.'
  }
];

export const stats = [
  { value: '500+', label: 'Clientes activos' },
  { value: '98%', label: 'Satisfacción' },
  { value: '50%', label: 'Ahorro de tiempo' },
  { value: '24/7', label: 'Soporte' }
];